import React, { useState, useEffect } from 'react';

/**
 * Component that displays the current time for a specified time zone
 * @param {Object} props
 * @param {string} props.timeZone - The time zone identifier (e.g., 'America/New_York')
 * @param {string} props.format - The time format ('12h' or '24h')
 * @param {string} props.label - Optional label for the time zone
 * @param {string} props.className - Additional CSS classes
 */
const WorldTime = ({ timeZone, format = '12h', label = '', className = '' }) => {
  const [time, setTime] = useState('');
  
  useEffect(() => {
    // Function to format the current time based on the time zone
    const updateTime = () => {
      try {
        const options = {
          timeZone,
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: format === '12h'
        };
        
        const formatter = new Intl.DateTimeFormat('en-US', options);
        const currentTime = formatter.format(new Date());
        setTime(currentTime);
      } catch (error) {
        console.error(`Error formatting time for ${timeZone}:`, error);
        setTime('Invalid timezone');
      }
    };
    
    // Update time immediately
    updateTime();
    
    // Set up interval to update every second
    const interval = setInterval(updateTime, 1000);
    
    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, [timeZone, format]);
  
  return (
    <span className={`world-time ${className}`}>
      {label && <span className="world-time-label">{label}: </span>}
      <span className="world-time-value">{time}</span>
    </span>
  );
};

export default WorldTime; 